import { VIEWING_APPLICANTS_FIELD_NAME } from './RentalPortalViewingProfileWidgetApplicants.constants'

function getViewingAdditionalApplicants(applicants) {
  return applicants.filter(applicant => !applicant.is_primary)
}

function toViewingApplicantSelectItem({ avatarColor, id, label }) {
  return {
    avatar: { color: avatarColor, text: label },
    label,
    value: id,
  }
}

export function toViewingApplicantsSelectItems(items) {
  return items.map(applicant =>
    toViewingApplicantSelectItem({
      avatarColor: applicant.avatar_color,
      id: applicant.id,
      label: applicant.identity.value,
    })
  )
}

export function getViewingApplicantsFormInitialValues(applicants) {
  return {
    [VIEWING_APPLICANTS_FIELD_NAME]: getViewingAdditionalApplicants(
      applicants
    ).map(applicant =>
      toViewingApplicantSelectItem({
        avatarColor: applicant.avatar_color,
        id: applicant.id,
        label: applicant.label,
      })
    ),
  }
}

export function getViewingApplicantsPayload(values) {
  return {
    applicant_ids: values[VIEWING_APPLICANTS_FIELD_NAME].map(
      item => item.value
    ),
  }
}

export function getViewingApplicantsRemovePayload({ applicants, removedId }) {
  return {
    applicant_ids: getViewingAdditionalApplicants(applicants)
      .filter(applicant => String(applicant.id) !== String(removedId))
      .map(applicant => applicant.id),
  }
}

export function getViewingPrimaryApplicantId(applicants) {
  return applicants.find(applicant => applicant.is_primary)?.id
}

export function getViewingApplicantsFieldLabelKey(primaryApplicantId) {
  return primaryApplicantId
    ? 'RentalPortal.ViewingApplicantsFieldLabelKey'
    : 'RentalPortal.ViewingApplicantsWidgetTitleKey'
}
